(function () {
  const SECTION = '[data-section-type="wim-collection-subcollection-pills"]';

  // Sliders activos de la sección. Un Set => un único listener de resize y
  // sin acumulación cuando el editor de temas recarga la sección.
  const sliders = new Set();

  function checkOverflow(slider) {
    const totalWidth = Array.from(slider.querySelectorAll('[data-slide]')).reduce(function (sum, cell) {
      return sum + cell.offsetWidth + (parseInt(getComputedStyle(cell).marginRight, 10) || 0);
    }, 0);
    const noOverflow = totalWidth <= slider.offsetWidth;
    slider.classList.toggle('wim-pills-no-overflow', noOverflow);

    // Si todas las pills caben no hay nada que recorrer: el autoplay sobra.
    const flkty = slider.flkty;
    if (flkty && flkty.options.autoPlay) {
      if (noOverflow) {
        flkty.stopPlayer();
      } else {
        flkty.playPlayer();
      }
    }
  }

  document.addEventListener('theme:slider:loaded', function (event) {
    const slider = event.detail && event.detail.slider;
    if (!slider || !slider.closest(SECTION)) return;

    sliders.add(slider);
    checkOverflow(slider);

    // El ancho de celda es width: max-content y depende de la fuente. Flickity
    // mide al iniciar; re-medimos cuando la webfont ya cargó para evitar celdas
    // pegadas o anchos obsoletos.
    const fontsReady = document.fonts ? document.fonts.ready : Promise.resolve();
    fontsReady.then(function () {
      if (slider.flkty) {
        slider.flkty.reloadCells();
        slider.flkty.reposition();
      }
      checkOverflow(slider);
    });
  });

  document.addEventListener('shopify:section:unload', function (event) {
    sliders.forEach(function (slider) {
      if (event.target.contains(slider)) {
        sliders.delete(slider);
      }
    });
  });

  document.addEventListener('theme:resize:width', function () {
    sliders.forEach(checkOverflow);
  });
})();
